var exports = {
  "Q": "xe533113f--66ba7d--content",
};

module.exports = exports;
